import type {
    AnimatedIconSignatureRow,
    AnimatedIconTime
} from "./type";

const LONG_1_5: AnimatedIconTime = [
    "long",
    1.5
];

const LONG_2: AnimatedIconTime = [
    "long",
    2
];

const MEDIUM: AnimatedIconTime = [
    "medium",
    1
];

const SHORT: AnimatedIconTime = [
    "short",
    1
];

const SHORT_HALF: AnimatedIconTime = [
    "short",
    0.5
];

const SHORT_1_5: AnimatedIconTime = [
    "short",
    1.5
];

export const ANIMATED_ICON_SIGNATURES: Record<string, Array<AnimatedIconSignatureRow>> = {
    "badge-question-mark": [
        {
            duration: LONG_1_5,
            motion: "swing",
            origin: [
                12,
                17
            ],
            part: [
                1,
                2
            ],
            r: 14
        }
    ],
    "map-pin": [
        {
            duration: LONG_1_5,
            motion: "drop",
            part: [
                0,
                1
            ],
            y: -6
        }
    ],
    "thumbs-up": [
        {
            duration: LONG_1_5,
            motion: "swing",
            origin: [
                7,
                21
            ],
            part: [
                0,
                1
            ],
            r: 12
        }
    ],
    "trash-2": [
        {
            duration: LONG_1_5,
            motion: "lift",
            origin: [
                3,
                6
            ],
            y: -1.5,
            part: [
                3,
                4
            ],
            r: -14
        }
    ],
    bell: [
        {
            duration: LONG_1_5,
            motion: "swing",
            origin: [
                12,
                2
            ],
            part: 1,
            r: 12
        },
        {
            duration: LONG_1_5,
            delay: SHORT_HALF,
            motion: "swing",
            origin: [
                12,
                2
            ],
            part: 0,
            r: 12
        }
    ],
    lock: [
        {
            duration: LONG_1_5,
            motion: "lift",
            part: 1,
            y: -3
        }
    ],
    moon: [
        {
            duration: LONG_1_5,
            motion: "swing",
            part: 0,
            r: 14
        }
    ],
    paperclip: [
        {
            duration: LONG_1_5,
            motion: "swing",
            part: 0,
            r: 10
        }
    ],
    pencil: [
        {
            duration: LONG_1_5,
            motion: "swing",
            origin: [
                3,
                21
            ],
            part: [
                0,
                1
            ],
            r: 8
        }
    ],
    "badge-check": [
        {
            duration: LONG_2,
            motion: "turn",
            part: 0,
            r: 45
        },
        {
            motion: "drawpop",
            delay: MEDIUM,
            easing: "out",
            part: 1
        }
    ],
    "badge-x": [
        {
            duration: LONG_2,
            motion: "turn",
            part: 0,
            r: 45
        },
        {
            delay: SHORT_HALF,
            motion: "turn",
            easing: "out",
            part: [
                1,
                2
            ],
            r: 90
        }
    ],
    "chart-column": [
        {
            motion: "grow",
            easing: "out",
            origin: [
                8,
                17
            ],
            part: 3,
            sy: 0
        },
        {
            delay: SHORT_HALF,
            motion: "grow",
            easing: "out",
            origin: [
                13,
                17
            ],
            part: 2,
            sy: 0
        },
        {
            motion: "grow",
            easing: "out",
            delay: SHORT,
            origin: [
                18,
                17
            ],
            part: 1,
            sy: 0
        }
    ],
    "circle-check": [
        {
            motion: "squash",
            part: 0,
            sx: 0.9,
            sy: 0.9
        },
        {
            motion: "drawpop",
            easing: "out",
            delay: SHORT,
            part: 1
        }
    ],
    "cloud-upload": [
        {
            motion: "through",
            duration: LONG_2,
            part: [
                0,
                2
            ],
            y: -5
        }
    ],
    "file-text": [
        {
            duration: MEDIUM,
            motion: "draw",
            easing: "out",
            part: 2
        },
        {
            delay: SHORT_HALF,
            duration: MEDIUM,
            motion: "draw",
            easing: "out",
            part: 3
        },
        {
            duration: MEDIUM,
            motion: "draw",
            easing: "out",
            delay: SHORT,
            part: 4
        }
    ],
    "log-out": [
        {
            motion: "through",
            duration: LONG_2,
            part: [
                0,
                1
            ],
            x: 5
        }
    ],
    "volume-2": [
        {
            duration: MEDIUM,
            motion: "fade",
            part: 1
        },
        {
            delay: SHORT_HALF,
            duration: MEDIUM,
            motion: "fade",
            part: 2
        }
    ],
    calendar: [
        {
            motion: "hop",
            part: 0,
            y: -2
        },
        {
            delay: SHORT_HALF,
            motion: "hop",
            part: 1,
            y: -2
        }
    ],
    check: [
        {
            motion: "drawpop",
            easing: "out",
            part: 0
        }
    ],
    download: [
        {
            motion: "through",
            duration: LONG_2,
            part: [
                0,
                2
            ],
            y: 5
        },
        {
            motion: "squash",
            delay: SHORT,
            origin: [
                12,
                21
            ],
            part: 1,
            sy: 0.85
        }
    ],
    ellipsis: [
        {
            motion: "hop",
            part: 2,
            y: -2
        },
        {
            delay: SHORT_HALF,
            motion: "hop",
            part: 0,
            y: -2
        },
        {
            motion: "hop",
            delay: SHORT,
            part: 1,
            y: -2
        }
    ],
    menu: [
        {
            motion: "squash",
            origin: [
                4,
                5
            ],
            part: 0,
            sx: 0.6
        },
        {
            delay: SHORT_HALF,
            motion: "squash",
            origin: [
                4,
                12
            ],
            part: 1,
            sx: 0.6
        },
        {
            motion: "squash",
            delay: SHORT,
            origin: [
                4,
                19
            ],
            part: 2,
            sx: 0.6
        }
    ],
    quote: [
        {
            motion: "hop",
            part: 1,
            y: -2
        },
        {
            delay: SHORT_HALF,
            motion: "hop",
            part: 0,
            y: -2
        }
    ],
    send: [
        {
            motion: "through",
            duration: LONG_2,
            part: [
                0,
                1
            ],
            x: 6,
            y: -6
        }
    ],
    sparkles: [
        {
            motion: "pop",
            part: 0,
            s: 1.15
        },
        {
            motion: "twinkle",
            delay: SHORT,
            origin: [
                20,
                4
            ],
            part: [
                1,
                2
            ]
        },
        {
            motion: "twinkle",
            delay: SHORT_1_5,
            origin: [
                4,
                20
            ],
            part: 3
        }
    ],
    upload: [
        {
            motion: "through",
            duration: LONG_2,
            part: [
                0,
                1
            ],
            y: -5
        }
    ],
    wifi: [
        {
            duration: MEDIUM,
            motion: "fade",
            part: 0
        },
        {
            delay: SHORT_HALF,
            duration: MEDIUM,
            motion: "fade",
            part: 3
        },
        {
            duration: MEDIUM,
            motion: "fade",
            delay: SHORT,
            part: 2
        },
        {
            delay: SHORT_1_5,
            duration: MEDIUM,
            motion: "fade",
            part: 1
        }
    ],
    zap: [
        {
            motion: "flicker",
            duration: LONG_2,
            part: 0
        }
    ],
    "refresh-cw": [
        {
            duration: LONG_2,
            motion: "turn",
            part: [
                0,
                1,
                2,
                3
            ],
            r: 180
        }
    ],
    "table-2": [
        {
            motion: "squash",
            sx: 0.85,
            part: 0,
            sy: 0.85
        }
    ],
    clock: [
        {
            duration: LONG_2,
            motion: "turn",
            part: 1,
            r: 360
        }
    ],
    heart: [
        {
            duration: LONG_2,
            motion: "beat",
            origin: [
                12,
                13
            ],
            part: 0
        }
    ],
    hourglass: [
        {
            duration: LONG_2,
            motion: "turn",
            part: [
                0,
                1,
                2,
                3
            ],
            r: 180
        }
    ],
    mail: [
        {
            duration: LONG_2,
            motion: "flip",
            origin: [
                12,
                7
            ],
            part: 0
        }
    ],
    minus: [
        {
            motion: "squash",
            part: 0,
            sx: 0.6
        }
    ],
    phone: [
        {
            duration: LONG_2,
            motion: "ring",
            part: 0,
            r: 12
        }
    ],
    search: [
        {
            duration: LONG_2,
            motion: "scan",
            part: [
                0,
                1
            ]
        }
    ],
    settings: [
        {
            duration: LONG_2,
            motion: "turn",
            part: 0,
            r: 180
        }
    ],
    sun: [
        {
            duration: LONG_2,
            motion: "turn",
            part: [
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8
            ],
            r: 45
        },
        {
            duration: LONG_2,
            motion: "squash",
            sx: 0.85,
            part: 0,
            sy: 0.85
        }
    ],
    "arrow-down": [
        {
            motion: "nudge",
            part: [
                0,
                1
            ],
            y: 3
        }
    ],
    "arrow-left": [
        {
            motion: "nudge",
            part: [
                0,
                1
            ],
            x: -3
        }
    ],
    "arrow-right": [
        {
            motion: "nudge",
            part: [
                0,
                1
            ],
            x: 3
        }
    ],
    "arrow-up": [
        {
            motion: "nudge",
            part: [
                0,
                1
            ],
            y: -3
        }
    ],
    "badge-alert": [
        {
            motion: "shake",
            part: [
                1,
                2
            ],
            x: 1.5
        }
    ],
    "chevron-down": [
        {
            motion: "nudge",
            part: 0,
            y: 2
        }
    ],
    "chevron-left": [
        {
            motion: "nudge",
            part: 0,
            x: -2
        }
    ],
    "chevron-right": [
        {
            motion: "nudge",
            part: 0,
            x: 2
        }
    ],
    "chevron-up": [
        {
            motion: "nudge",
            part: 0,
            y: -2
        }
    ],
    "circle-alert": [
        {
            motion: "shake",
            part: [
                1,
                2
            ],
            x: 1.5
        }
    ],
    "external-link": [
        {
            motion: "nudge",
            part: [
                0,
                1
            ],
            x: 2,
            y: -2
        }
    ],
    "log-in": [
        {
            motion: "enter",
            easing: "out",
            part: [
                0,
                1
            ],
            x: -6
        }
    ],
    "panel-left-close": [
        {
            motion: "nudge",
            part: 2,
            x: -2
        }
    ],
    "panel-left-open": [
        {
            motion: "nudge",
            part: 2,
            x: 2
        }
    ],
    "shopping-cart": [
        {
            motion: "nudge",
            part: [
                0,
                1,
                2
            ],
            x: 3
        }
    ],
    "user-plus": [
        {
            motion: "enter",
            easing: "out",
            origin: [
                19,
                11
            ],
            part: [
                2,
                3
            ],
            r: -90,
            s: 0.4
        }
    ],
    bookmark: [
        {
            motion: "enter",
            easing: "out",
            part: 0,
            y: -5
        }
    ],
    copy: [
        {
            motion: "enter",
            easing: "out",
            part: 0,
            x: -6,
            y: -6
        }
    ],
    eye: [
        {
            motion: "blink",
            part: [
                0,
                1
            ]
        }
    ],
    link: [
        {
            motion: "nudge",
            part: 0,
            x: 1.5,
            y: -1.5
        },
        {
            motion: "nudge",
            part: 1,
            x: -1.5,
            y: 1.5
        }
    ],
    printer: [
        {
            motion: "enter",
            easing: "out",
            part: 2,
            y: -5
        }
    ],
    "circle-x": [
        {
            motion: "turn",
            easing: "out",
            part: [
                1,
                2
            ],
            r: 90
        }
    ],
    house: [
        {
            motion: "hop",
            part: 1,
            y: -1.5
        },
        {
            motion: "grow",
            easing: "out",
            delay: SHORT,
            origin: [
                12,
                21
            ],
            part: 0,
            sy: 0
        }
    ],
    plus: [
        {
            motion: "turn",
            easing: "out",
            part: [
                0,
                1
            ],
            r: 90
        }
    ],
    x: [
        {
            motion: "turn",
            easing: "out",
            part: [
                0,
                1
            ],
            r: 90
        }
    ],
    "badge-info": [
        {
            motion: "hop",
            part: 2,
            y: -3
        }
    ],
    "user-round": [
        {
            motion: "hop",
            part: 0,
            y: -2
        }
    ],
    inbox: [
        {
            motion: "hop",
            part: 0,
            y: 2
        }
    ],
    info: [
        {
            motion: "hop",
            part: 2,
            y: -3
        }
    ],
    star: [
        {
            motion: "pop",
            part: 0,
            r: -12,
            s: 1.2
        }
    ]
};
